<template>
  <section>
    <base-section-title>#{{ $t("projects.title") }}'</base-section-title>
    <base-loading v-if="loading" />
    <div v-else class="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-3">
      <base-project-card @click.native="openModal(project)"
        v-for="project in getFirstProjects(3)" :key="'card_project_' + project.id"
        :project="project" />
      <router-link to="/projects" class="fake-project-card" style="min-height: 250px">
        <p><i class="fas fa-plus text-6xl"></i></p>
        <p>{{ $t('see-more')}}</p>
      </router-link>
    </div>
    <transition name="slide-up">
      <base-project-modal @onCloseModal="closeModal" :is-fullscreen="true" v-if="showModal" :project="selectedProject"/>
    </transition>
  </section>
</template>

<script>
import BaseSectionTitle from '../../base/BaseSectionTitle'
import BaseProjectCard from '../../base/project/BaseProjectCard'
import { mapGetters } from 'vuex'
import store from '../../../store'
import BaseLoading from '../../base/BaseLoading'
import BaseProjectModal from '../../base/modals/BaseProjectModal'

export default {
  name: 'ProjectsSection',
  data () {
    return {
      loading: true,
      showModal: false,
      selectedProject: null
    }
  },
  components: { BaseProjectModal, BaseLoading, BaseProjectCard, BaseSectionTitle },
  methods: {
    openModal (project) {
      this.selectedProject = project
      this.showModal = true
    },
    closeModal () {
      this.selectedProject = null
      this.showModal = false
    },
    fetchData () {
      store.dispatch('projects/getProjects',
        { language: this.$i18n.locale })
        .then(() => {
          this.loading = false
        })
    }
  },
  computed: {
    ...mapGetters('projects', ['getFirstProjects', 'getAllProjects'])
  },
  mounted () {
    if (this.getAllProjects.length === 0) this.fetchData()
    else this.loading = false
  },
  watch: {
    '$i18n.locale': {
      handler () {
        this.loading = true
        store.dispatch('projects/resetState').then(() => {
          this.fetchData()
        })
      }
    }
  }
}
</script>

<style scoped>
.fake-project-card {
  @apply rounded border border-black flex flex-col justify-center items-center text-2xl font-bold;
  transition: all .5s linear;
}
.fake-project-card:hover {
  @apply bg-black text-white;
}
</style>
